import Admin from '@/models/Admin'
import IntegrationDefault from '@/models/IntegrationDefault'
import Plan from '@/models/Plan'
import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
  state:()=>( {
    currentAdmin:null,
    webpayMallDefaults:null,
    admins:[],
    plans:[],
    planModalities:[
      {id:'mensual',label:'Mensual'},
      {id:'anual',label:'Anual'},
    ],
  }),
  getters: {
    hasLoggedIn(state){
      return state.currentAdmin !== null
    },
    planById(state){
      return (id)=>{
        return state.plans.find((p)=>{
          return p.id === id
        })
      }
    }
  },
  actions: {
    async login(user){
      this.currentAdmin = user
      this.getPlans()
      this.getWebpayMallIntegrationDefaults()
      this.getAdmins()
    },
    logout(){
      this.currentAdmin = null
    },
    async getAdmins(){
      this.admins = await Admin.all()
    },
    async getPlans(){
      this.plans = await Plan.all()
    },
    async getWebpayMallIntegrationDefaults(){
      this.webpayMallDefaults = await IntegrationDefault.find('webpay-mall')  
    }
  },
})
